<template>
  <div class="overlay" @click.self="$emit('close')">
    <div class="panel">
      <h2>Confirm Delete</h2>
      <p>Are you sure you want to delete <strong>{{ foodName }}</strong>?</p>
      <div class="buttons">
        <button class="cancel" @click="$emit('close')">Cancel</button>
        <button class="confirm" @click="$emit('confirm')">Yes, Delete</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmDelete",
  props: {
    foodName: { type: String, default: "" }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel {
  background: #222;
  color: #fff;
  padding: 1.5rem;
  border-radius: 12px;
  max-width: 300px;
  width: 80%;
  text-align: center;
}

.buttons {
  margin-top: 1rem;
  display: flex;
  justify-content: space-around;
}

button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

button.cancel {
  background: #555;
  color: #fff;
}

button.confirm {
  background: #ff4d4d;
  color: #fff;
}
</style>
